import React, { CSSProperties, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { GetAdminSettingValue, InsertPPLogs } from "../api";
import { useNavigate } from "react-router-dom";
import HomeIcon from '@mui/icons-material/Home';//FB 7541

// Update log
// FB  6192   02/06/2023  DK  Added page to handle navbar to be displayed
// FB  7000   06/22/2023  DK  Portal issues
// FB  6997   10/09/2023  SK  Patient Portal: All the api's that shows results in the Patient portal needs fine tuning
// FB  7541   10/16/2023  SK  Implementing a feature that allows patients to upload clinical documents via a patient portal
// FB  7876   02/21/2024  GA  Setup Patient Portal for Makovsky
// FB  8478   03/25/2024  DK  cannot read patient data on portal
// FB  9464   10/08/2024  KI    created new screen for displaying lab orders

const styles: any = {
  li: {
    float: "left",
    width: "180px",     //FB 7000
    background: "white",
    listStyle: "none",
    border: "1px  gray",
    textAlign: "center",
    fontWeight: "bold",
  },
};

const activeStyleProps: CSSProperties = {
  fontWeight: "bold",
  color: "#13607C",
  textDecorationColor: "#EB7100",
  textDecorationThickness: "3px",
};

/*
  Just a menu.
*/
export default function NavBar() {
  // const navigate = useNavigate();
  // let patientName = "User";
  // let data = sessionStorage.getItem("user");
  // if (data != null) {
  //   patientName = JSON.parse(data).PatientFirstName;
  // }
  // const ViewAppointments = async () => {
  //   InsertPPLogs(
  //     "Appointments - NAVBAR",
  //     window.location.href,
  //     patientName,
  //     ""
  //   );
  // };
  // const ViewMessages = async () => {
  //   InsertPPLogs("Messages - NAVBAR", window.location.href, patientName, "");
  // };
  // const ViewDashboard = async () => {
  //   navigate("/user/home/dashboard");
  //   InsertPPLogs("Dashboard - NAVBAR", window.location.href, patientName, "");
  // };
  // const ViewTestResults = async () => {
  //   InsertPPLogs(
  //     "Test Results - NAVBAR",
  //     window.location.href,
  //     patientName,
  //     ""
  //   );
  // };
  // const PayBill = async () => {
  //   InsertPPLogs("Billing - NAVBAR", window.location.href, patientName, "");
  // };
  // const MyRecord = async () => {
  //   InsertPPLogs("MyRecord - NAVBAR", window.location.href, patientName, "");
  // };
  //FB 7876 Begin
  const [enableAppointments, setEnableAppointments] = useState(false);
  const [enableMessages, setEnableMessages] = useState(false);
  const [enableTestResults, setEnableTestResults] = useState(false);
  const [enableMyRecords, setEnableMyRecords] = useState(false);
  const [enablebilling, setEnableBilling] = useState(false);
  const [enableClinicalDocs, setEnableClinicalDocs] = useState(false);
  const [enableLabOrders, setenableLabOrders] = useState(false); //FB 9464
  async function LoadBillingNavLink() {
    let setting = sessionStorage.getItem("enable_portal_dashboard_options");

    //FB 8478
    if (setting == undefined || setting == null) {
      let value = await GetAdminSettingValue("enable_portal_dashboard_options");
      setting = value;
      sessionStorage.setItem("enable_portal_dashboard_options", value);
    }
    
    if (setting) {
      const values = setting.split(',').map(Number); 
      setEnableAppointments(values.includes(1));
      setEnableMessages(values.includes(2));
      setEnableTestResults(values.includes(3));
      setEnableMyRecords(values.includes(4));
      setEnableBilling(values.includes(5));
      setEnableClinicalDocs(values.includes(6));
      setenableLabOrders(values.includes(7)); //FB 9464
    }
  }
  //FB 7876 End

  useEffect(() => {
    LoadBillingNavLink() //FB 7876
  }, []);

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <ul
        style={{
          paddingTop: "1em",
          borderStyle: "solid",
          borderWidth: "5px",
          borderColor: "white",
          margin: "auto",
          marginBottom: "2em",
          paddingLeft:"0px"     //FB 7000
        }}
      >
        <li style={styles.li}>
          <NavLink
            to="/user/home/dashboard"
            // FB 7541 - Begin
            style={({ isActive }) => ({
              display: 'flex', // Make the link a flex container
              alignItems: 'center', // Vertically center the content
              fontWeight: 'bold',
              color: isActive ? '#13607C' : '#13607C',
              textDecoration: 'none',
            })}
          >
            Dashboard<HomeIcon style={{ marginLeft: '5px' }} />
            {/* FB 78541 - End */}
          </NavLink>
        </li>

        <li style={styles.li}>
          <NavLink
            to="/user/home/Appointments"
            style={({ isActive }) =>
              isActive
                ? {
                  fontWeight: "bold",
                  color: "#13607C",
                  paddingBottom: "2px",
                  borderBottom: "3px solid #EB7100",
                  textDecoration: "none",
                  display: enableAppointments ? "block" : "none"

                }
                : { color: "#13607C", textDecoration: "none",display: enableAppointments ? "block" : "none"
              }
            }
          >{/* FB 7876 */}
            Appointments
          </NavLink>
        </li>

        <li style={styles.li}>
          <NavLink
            to="/user/home/Messages"
            style={({ isActive }) =>
              isActive
                ? {
                  fontWeight: "bold",
                  color: "#13607C",
                  paddingBottom: "2px",
                  borderBottom: "3px solid #EB7100",
                  textDecoration: "none",
                  display: enableMessages ? "block" : "none"
                }
                : { color: "#13607C", textDecoration: "none",display: enableMessages ? "block" : "none" }
            }
          >{/* FB 7876 */}
            Messages
          </NavLink>
        </li>
        <li style={styles.li}>
          <NavLink
            to="/user/home/TestResults"
            style={({ isActive }) =>
              isActive
                ? {
                  fontWeight: "bold",
                  color: "#13607C",
                  paddingBottom: "2px",
                  borderBottom: "3px solid #EB7100",
                  textDecoration: "none",
                  display: enableTestResults ? "block" : "none"
                }
                : { color: "#13607C", textDecoration: "none",display: enableTestResults ? "block" : "none" }
            }
          >{/* FB 7876 */}
            Test results
          </NavLink>
        </li>
        <li style={styles.li}>
          <NavLink
            to="/user/home/Billing"
            style={({ isActive }) =>
              isActive
                ? {
                  fontWeight: "bold",
                  color: "#13607C",
                  paddingBottom: "2px",
                  borderBottom: "3px solid #EB7100",
                  textDecoration: "none",
                  display: enablebilling ? "block" : "none"
                }
                : { color: "#13607C", textDecoration: "none", display: enablebilling ? "block" : "none" }
            }
          >{/* FB 7876 */}
            Billing
          </NavLink>
        </li>
        <li style={styles.li}>
          <NavLink
            to="/user/home/Myrecord"
            style={({ isActive }) =>
              isActive
                ? {
                  fontWeight: "bold",
                  color: "#13607C",
                  paddingBottom: "2px",
                  borderBottom: "3px solid #EB7100",
                  textDecoration: "none",
                  display: enableMyRecords ? "block" : "none"
                }
                : { color: "#13607C", textDecoration: "none",display: enableMyRecords ? "block" : "none" }
            }
          >{/* FB 7876 */}
            My Records
          </NavLink>{/* FB 7541 */}
        </li>
        <li style={styles.li}>
          <NavLink
            to="/user/home/clinicaldocuments"
            style={({ isActive }) =>
              isActive
                ? {
                  fontWeight: "bold",
                  color: "#13607C",
                  paddingBottom: "2px",
                  borderBottom: "3px solid #EB7100",
                  textDecoration: "none",
                  display: enableClinicalDocs ? "block" : "none"
                }
                : { color: "#13607C", textDecoration: "none",display: enableClinicalDocs ? "block" : "none" }
            }
          >{/* FB 7876 */}
            Clinical documents
          </NavLink>
        </li>
        {/* FB 9464 */}
        <li style={styles.li}>
          <NavLink
            to="/user/home/LabOrdering"
            style={({ isActive }) =>
              isActive
                ? {
                  fontWeight: "bold",
                  color: "#13607C",
                  paddingBottom: "2px",
                  borderBottom: "3px solid #EB7100",
                  textDecoration: "none",
                  display: enableLabOrders ? "block" : "none"
                }
                : { color: "#13607C", textDecoration: "none",display: enableLabOrders ? "block" : "none" }
            }
          >
            Lab Orders
          </NavLink>
        </li>
      </ul>
    </div>
  );
}
